// extracted by mini-css-extract-plugin
export default {"cart_counter_block":"style_cart_counter_block__rUK-K","counterBtn":"style_counterBtn__hjg3W"};